module.exports = __webpack_public_path__ + "assets/fire-hydrant.45d6d5dc.svg";